import React, { useState } from 'react';
import classes from './liveViewSearchBar.module.css';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Divider } from 'primereact/divider';
import ExportExcel from '../../components/ExcelExport/ExcelExport';

const cameraTypeOptions = [
  { label: 'Hikvision', value: 'HIKVISION' },
  { label: 'Dahua', value: 'DAHUA' },
  { label: 'AJAX', value: 'AJAX' },
  { label: 'AIBox', value: 'AIBOX' },
];

const LiveViewCamerasSearchBar = ({
  placeholder,
  value,
  onChange,
  cameraTypeFilter,
  setCameraTypeFilter,
  excelData,
  fileName,
}) => {

  const [showFilters, setShowFilters] = useState(false);
  const [localTypeFilter, setLocalTypeFilter] = useState(cameraTypeFilter);

  const handleClear = () => onChange({ target: { value: '' } });
  //TODO - finish filters for camera
  //Change live view sites filters to use AllSitesSearchBar with liveviewenabled auto selected
  //Update What's new
  //Update Server
  //Update ListSitesWithLiveView SP
  //Update GetUserActivity SP
  //Point back to live server
  //Release Portal

  const handleApply = () => {
    setCameraTypeFilter(localTypeFilter);
    setShowFilters(false);
  };

  const handleReset = () => {
    setLocalTypeFilter([]);
    setCameraTypeFilter([]);
    setShowFilters(false);
  };

  const hasActiveFilters = cameraTypeFilter && cameraTypeFilter.length > 0;

  return (
    <div className={classes.wrapper}>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          spellCheck={false}
        />
        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">
              ×
            </button>
          )}
          {/* <button className={classes.filterButton} onClick={() => setShowFilters(p => !p)} type="button">
            <img style={{ height: '30px', width: '30px', opacity: hasActiveFilters ? 1 : 0.5 }} src={filters} />
          </button> */}
        </div>

        {showFilters && (
          <div className={classes.filterDropdown}>
            <div className={classes.filterRow}>
              <label className={classes.filterLabel}>Camera type:</label>
              <MultiSelect
                value={localTypeFilter}
                onChange={(e) => setLocalTypeFilter(e.value)}
                options={cameraTypeOptions}
                optionLabel="label"
                placeholder="All types"
                className="w-full md:w-14rem"
                style={{ width: '280px' }}
                checkmark
                highlightOnSelect={false}
              />
            </div>
            <Divider type="solid" />
            <div className={classes.buttonRow}>
              <Button icon="pi pi-refresh" type="button" label="Reset" onClick={handleReset} outlined severity="danger" />
              <Button icon="pi pi-check" type="button" label="Apply" onClick={handleApply} />
            </div>
          </div>
        )}
      </div>

      <ExportExcel
        excelData={excelData}
        fileName={fileName}
        title={fileName}
        colWidths={[{ wch: 30 }, { wch: 20 }, { wch: 20 }, { wch: 30 }, { wch: 30 }]}
      />
    </div>
  );
};

export default LiveViewCamerasSearchBar;
